import { Space, Tag, Typography } from "antd";
import { useKycRefine } from "hook/base/kyc/useKyc";
import React, { useState } from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const KycHeader = () => {
  // -------------------------- VAR -----------------------------
  const { data } = useKycRefine();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Space style={{ display: "flex", alignItems: "center" }}>
      <Typography.Title style={{ margin: 0 }} level={3}>
        KYC Request
      </Typography.Title>
      <Tag style={{ borderRadius: 30 }}>{data?.length || 0} request</Tag>
    </Space>
  );
};
export default KycHeader;
